export enum MenuOption {
  Share,
  MakeCall,
  ReceiveCall,
  LogInteraction,
  WriteEmail,
  ScheduleMeeting,
  ScheduleToDo,
  AddNote,
  AddDocument,
  CreateOpportunity,
  CreateCustomerServiceCase,
  DrawAMap,
  StartWorkflow,
}

export enum MenuOptionName {
  Share = 'share',
  MakeCall = 'makeCall',
  ReceiveCall = 'receiveCall',
  LogInteraction = 'interaction',
  WriteEmail = 'email',
  ScheduleMeeting = 'scheduleMeeting',
  ScheduleToDo = 'scheduleToDo',
  AddNote = 'note',
  AddDocument = 'document',
  CreateOpportunity = 'createOpportunity',
  CreateCustomerServiceCase = 'createCustomerServiceCase',
  DrawAMap = 'drawAMap',
  StartWorkflow = 'startWorkflow',
}
